import { connect } from 'react-redux';
import { useState, useEffect } from 'react';
import { NavLink } from "react-router-dom"
import { InAppTemplate } from "../../../shared/templates/inapp";
import { Formik, Form, Field, FormikProps, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import AddIco from "../../../assets/add.svg"
import Walmart from "../../../assets/icons/walmart.svg"
import { storeActions } from "../../../redux/actions/in-app"
import { LoadingItem } from "../../../shared/components/loading"
import { AlertMsg } from "../../../shared/components/alert-msg"
import TrashIcon from "../../../assets/icons/delete.png"
import { TableComponent } from "../../../shared/components/table"
import Modal from 'react-bootstrap/Modal'
import PhoneInput from "react-phone-input-2";

const getStaffListAction = async ({ pageProps, payload }: any) => {
    await pageProps.getStaffList(payload);
}

const addAStaffAction = async ({ pageProps, payload }: any) => {

    await pageProps.addAStaff(payload);
}

const deleteAStaffAction = async ({ pageProps, payload }: any) => {

    await pageProps.deleteAStaff(payload);
}


let detailsValidationSchema = Yup.object().shape({
    staffMail: Yup.string()
        .required("Required"),
    firstName: Yup.string()
        .required("Required"),
    lastName: Yup.string()
        .required("Required"),
    phoneNumber: Yup.string()
        .required("Required"),
    staffRole: Yup.string()
        .required("Required")


});
let deleteModalValidationSchema = Yup.object().shape({
    deleteReason: Yup.string()
        .required("Required"),

});
let initialValues: any = {
    staffMail: "",
    firstName: "",
    lastName: "",
    phoneNumber: "",
    staffRole: ""
}

let deleteInitialValues: any = {
    deleteReason: "",
}
const InviteStaff = ({ showInvite, setShowInviteModal, pageProps }: any) => {
    useEffect(() => {
        addAStaffAction({
            pageProps,
            payload: "CLEAR"
        })
    }, [])
    return (
        <Modal className="invite_staff_wrap" show={showInvite} onHide={() => {
            if (!pageProps.addAStaffRequest?.is_request_processing) {
                setShowInviteModal(false)
            }
        }}>
            <Modal.Header closeButton>
                Add a new staff
            </Modal.Header>
            <Modal.Body>
                {pageProps.addAStaffRequest.request_status !== "ADD_A_STAFF_SUCCESS" &&
                    <Formik
                        initialValues={initialValues}
                        validationSchema={detailsValidationSchema}
                        onSubmit={(values: any, actions) => {
                            let loggedAccountInfo: any = localStorage.getItem("mamiVendorXAuth") || "{}";
                            loggedAccountInfo = JSON.parse(loggedAccountInfo);
                            let payload = {
                                storeId: loggedAccountInfo.selectedStore.id,
                                email: values?.staffMail,
                                phoneNumber: values?.phoneNumber,
                                firstName: values?.firstName,
                                lastName: values?.lastName,
                                // "city": "string",
                                storeRoleEnum: parseInt(values?.staffRole)
                            }

                            addAStaffAction({ pageProps, payload })
                        }}
                    >
                        {(props: FormikProps<any>) => {
                            const {
                                values,
                                touched,
                                errors,
                                setFieldTouched,
                                handleChange,
                                setFieldValue,
                            } = props;
                            return (
                                <Form>
                                    <div className="form-wrap">
                                        <div className="">
                                            <div className="form-group">
                                                <label htmlFor="firstName">First Name</label>
                                                <Field
                                                    id="firstName"
                                                    value={values.firstName}
                                                    name="firstName"
                                                    type="text"
                                                    placeholder="Enter the team member's first name"
                                                    onChange={handleChange}
                                                    className={`input-wrap ${errors.firstName && touched.firstName ?
                                                        "is-invalid-input "
                                                        : values.firstName !== "" ? "valid-input" : ""}`}
                                                />
                                                <ErrorMessage name="firstName" className="form-input-error" component="div" />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="lastName">Last Name</label>
                                                <Field
                                                    id="lastName"
                                                    value={values.lastName}
                                                    name="lastName"
                                                    type="text"
                                                    placeholder="Enter the team member's last name"
                                                    onChange={handleChange}
                                                    className={`input-wrap ${errors.lastName && touched.lastName ?
                                                        "is-invalid-input "
                                                        : values.lastName !== "" ? "valid-input" : ""}`}
                                                />
                                                <ErrorMessage name="lastName" className="form-input-error" component="div" />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="phoneNumber">Phone number</label>
                                                <PhoneInput
                                                    country={"ca"}
                                                    enableTerritories={false}
                                                    enableSearch={true}
                                                    disableSearchIcon={true}
                                                    inputClass={`input-wrap ${errors.phoneNumber && touched.phoneNumber
                                                        ? "is-invalid-input "
                                                        : values.phoneNumber !== ""
                                                            ? "valid-input"
                                                            : ""
                                                        }`}
                                                    value={values.phoneNumber}
                                                    onChange={(phone: string): void => {
                                                        setFieldTouched("phoneNumber", true);
                                                        setFieldValue("phoneNumber", phone);
                                                    }}
                                                />
                                                <ErrorMessage name="phoneNumber" className="form-input-error" component="div" />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="staffMail">Email</label>
                                                <Field
                                                    id="staffMail"
                                                    value={values.staffMail}
                                                    name="staffMail"
                                                    type="text"
                                                    placeholder="Staff email"
                                                    onChange={handleChange}
                                                    className={`input-wrap ${errors.staffMail && touched.staffMail ?
                                                        "is-invalid-input "
                                                        : values.staffMail !== "" ? "valid-input" : ""}`}
                                                />
                                                <ErrorMessage name="staffMail" className="form-input-error" component="div" />
                                            </div>

                                            <div className="form-group">
                                                <label htmlFor="staffRole">Role</label>
                                                <select onChange={handleChange} name="staffRole" id="staffRole" value={values?.staffRole}
                                                    className={`input-wrap ${errors.staffRole && touched.staffRole ?
                                                        "is-invalid-input "
                                                        : values.staffRole !== "" ? "valid-input" : ""}`}
                                                >
                                                    <option value="" disabled></option>
                                                    <option value="0">Associate</option>
                                                    <option value="1">Manager</option>
                                                </select>

                                                <ErrorMessage name="staffRole" className="form-input-error" component="div" />
                                            </div>




                                        </div>

                                    </div>
                                    {pageProps.addAStaffRequest.request_status === "ADD_A_STAFF_FAILURE" &&
                                        <AlertMsg type="error" message={pageProps.addAStaffRequest?.request_data.error} />
                                    }
                                    <div className="invite-cta">
                                        <button
                                            disabled={pageProps.addAStaffRequest?.is_request_processing}
                                            className="btn">{pageProps.addAStaffRequest?.is_request_processing ? "Please wait.." : "Add Staff"}  </button>
                                    </div>
                                </Form>
                            )
                        }}

                    </Formik>
                }
                {pageProps.addAStaffRequest.request_status === "ADD_A_STAFF_SUCCESS" &&
                    <AlertMsg type="success" message="Staff has been successfully added" />
                }
            </Modal.Body>
        </Modal>
    )
}

const DeleteStaff = ({ staff, showDelete, setShowDeleteModal, pageProps }: any) => {
    useEffect(() => {
        deleteAStaffAction({
            pageProps,
            payload: "CLEAR"
        })
    }, [])
    return (
        <Modal className="invite_staff_wrap" show={showDelete !== null} onHide={() => {
            if (!pageProps.deleteAStaffRequest?.is_request_processing) {
                setShowDeleteModal(null)
            }
        }}>

            <Modal.Body>
                {pageProps.deleteAStaffRequest.request_status !== "DELETE_A_STAFF_SUCCESS" &&
                    <Formik
                        initialValues={deleteInitialValues}
                        validationSchema={deleteModalValidationSchema}
                        onSubmit={(values: any, actions) => {
                            let loggedAccountInfo: any = localStorage.getItem("mamiVendorXAuth") || "{}";
                            loggedAccountInfo = JSON.parse(loggedAccountInfo);
                            let payload = `?userId=${staff?.id}&storeId=${loggedAccountInfo.selectedStore.id}`

                            deleteAStaffAction({ pageProps, payload })
                        }}
                    >
                        {(props: FormikProps<any>) => {
                            const {
                                values,
                                touched,
                                errors,
                                setFieldTouched,
                                handleChange,
                                setFieldValue,
                            } = props;
                            return (
                                <Form>
                                    <div className="form-wrap">
                                        <div className="">
                                            <div className="form-group">
                                                <label htmlFor="deleteReason" className="delete-reason">Are you sure to delete {staff?.firstName} {staff?.lastName}?</label>
                                                <Field
                                                    id="deleteReason"
                                                    value={values.deleteReason}
                                                    name="deleteReason"
                                                    as="textarea"
                                                    placeholder={`Why do you want to delete ${staff?.firstName} ${staff?.lastName}'s account?`}
                                                    onChange={handleChange}
                                                    className={`input-wrap delete-msg ${errors.deleteReason && touched.deleteReason ?
                                                        "is-invalid-input "
                                                        : values.deleteReason !== "" ? "valid-input" : ""}`}
                                                />
                                                <ErrorMessage name="deleteReason" className="form-input-error" component="div" />
                                            </div>






                                        </div>

                                    </div>
                                    {pageProps.deleteAStaffRequest.request_status === "DELETE_A_STAFF_FAILURE" &&
                                        <AlertMsg type="error" message={pageProps.deleteAStaffRequest?.request_data.error} />
                                    }
                                    <div className="delete-ctas">
                                        <button disabled={pageProps.deleteAStaffRequest?.is_request_processing} className="btn confirm">Yes</button>
                                        <button disabled={pageProps.deleteAStaffRequest?.is_request_processing} className="btn">No</button>
                                    </div>
                                </Form>
                            )
                        }}

                    </Formik>
                }
                {pageProps.deleteAStaffRequest.request_status === "DELETE_A_STAFF_SUCCESS" &&
                    <AlertMsg type="success" message="Staff has been successfully deleted" />
                }
            </Modal.Body>
        </Modal>
    )
}
const InAppContent = ({ pageProps }: any) => {
    const [showInvite, setShowInviteModal] = useState(false);
    const [showDelete, setShowDeleteModal] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(40);


    useEffect(() => {

        let loggedAccountInfo: any = localStorage.getItem("mamiVendorXAuth") || "{}";
        loggedAccountInfo = JSON.parse(loggedAccountInfo);
        // let payload = `Page=${page}&Size=${size}&StoreId=${loggedAccountInfo.selectedStore.id}`;
        let payload = `Page=${pageNumber}&Size=${pageSize}&StoreId=${loggedAccountInfo.selectedStore.id}`;
        getStaffListAction({
            pageProps,
            payload
        })

        deleteAStaffAction({
            pageProps,
            payload: "CLEAR"
        })
        addAStaffAction({
            pageProps,
            payload: "CLEAR"
        })


    }, [])






    const ReportTable = ({ data }: any) => {

        return (
            <>
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Role</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        data?.results.map((staff: any, index: any) => {
                            return (
                                <tr key={index}>
                                    <td>
                                        <div className="name_wrap">
                                            <div className={`role_box ${staff?.role == "StaffManager" ? "manager" : "others"}`}>
                                                {staff?.role == "StaffManager" ? "M" : "A"}
                                            </div>
                                            <div className="name_info">
                                                <div className="name_text">{staff?.firstName} {staff?.lastName} </div>
                                                <div className="email_text">{staff?.email}</div>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <span className={`role_amber ${staff?.role == "StaffManager" ? "manager" : "others"}`}>{staff?.role} </span>
                                    </td>
                                    <td>
                                        <div className="deleteicon delete_cta" onClick={() => setShowDeleteModal(staff)}>
                                            {/* <img src={TrashIcon} alt="" className="" width={15} /> */}
                                            <span>Delete</span>
                                        </div>
                                    </td>
                                </tr>
                            )
                        })
                    }

                </tbody>
            </>
        )
    }



    return (
        <div className="inapp-content">
            <div className="page-content cards setting-page">
                {showInvite && <InviteStaff showInvite={showInvite} setShowInviteModal={setShowInviteModal} pageProps={pageProps} />}
                {showDelete && <DeleteStaff staff={showDelete} showDelete={showDelete} setShowDeleteModal={setShowDeleteModal} pageProps={pageProps} />}
                <div className="page-heading">
                    <h3>Settings</h3>
                </div>
                <div className="page-menus">
                    <NavLink end className={({ isActive }) => (isActive ? 'active-nav' : '')} to="/app/profile">
                        Store Details
                    </NavLink>
                    {/* <NavLink end className={({ isActive }) => (isActive ? 'active-nav' : '')} to="/app/profile/store">
                        Store Details
                    </NavLink> */}
                    <NavLink end className={({ isActive }) => (isActive ? 'active-nav' : '')} to="/app/profile/staff">
                        Staff Account
                    </NavLink>
                    <NavLink end className={({ isActive }) => (isActive ? 'active-nav' : '')} to="/app/profile/withdrawal">
                        Withdrawal Method
                    </NavLink>
                </div>

            </div>

            {pageProps.getAllStaffRequest.request_status === "GET_STAFF_LIST_PENDING" &&
                <div className="cards setting-page">
                    <LoadingItem />
                </div>
            }
            {pageProps.getAllStaffRequest.request_status === "GET_STAFF_LIST_SUCCESS" &&
                <div className="cards setting-page">
                    <div className="light-heading">
                        <h5 className="team_heading">Manage your team members</h5>
                        <div className="staff_ctas">
                            <button className="btn add" onClick={() => setShowInviteModal(true)}>
                                <img src={AddIco} alt="" />
                                Add new staff
                            </button>
                        </div>

                    </div>
                    <div className="staff-table">
                        <TableComponent
                            childComponent={<ReportTable data={pageProps.getAllStaffRequest?.request_data?.response} />}
                        />
                    </div>

                </div>
            }
            {pageProps.getAllStaffRequest.request_status === "GET_STAFF_LIST_FAILURE" &&
                <AlertMsg type="error" message={pageProps.getAllStaffRequest?.request_data.error} />
            }
        </div>
    )
}

const StaffProfiles = (pageProps: any) => {
    return (
        <InAppTemplate pageHeadingTitle="Personal Profile" childComponent={<InAppContent pageProps={pageProps} />} />
    )
}


const mapDispatchToProps = {
    getStaffList: storeActions.GetStaffList,
    addAStaff: storeActions.AddAStaff,
    deleteAStaff: storeActions.DeleteAStaff,
};

const mapStateToProps = (state: any) => ({
    // return {
    addAStaffRequest: state.allProductReducers.addAStaffReducer,
    deleteAStaffRequest: state.allProductReducers.deleteAStaffReducer,
    getAllStaffRequest: state.allProductReducers.getAllStaffReducer,

    // };
})
export default connect(mapStateToProps, mapDispatchToProps)(StaffProfiles);